module.exports = __webpack_public_path__ + "img/Sopyo.ab494acb.png";